import { jsx as _jsx } from "react/jsx-runtime";
import { AuthView } from './auth_view';
/**
 *  Styles will be inlined since these components will be rendered for PDF generation
 */
export const StudyNameWithNoPIIPreview = ({ messages, productMessages }) => {
    if (!messages) {
        return null;
    }
    return [
        _jsx(AuthView, { title: messages.value, productMessages: productMessages, isNoPIIEnabled: false }, 'study-name-nopii'),
    ];
};
//# sourceMappingURL=study_name.previews.component.js.map